import PropTypes from 'prop-types'
import classNames from 'classnames'
import BaseBreadcrumb from '../../breadcrumb'

const Breadcrumb = ({ resource, ...attrs }) => {
  attrs.className = classNames(
    attrs.className,
    [
      'bg-white',
      'relative',
      'pb-20'
    ]
  )

  return <section {...attrs}>
    <div
      className={
        classNames([
          'relative',
          'container',
          'px-4'
        ])
      }>
      <BaseBreadcrumb
        items={[
          {
            text: 'Recursos',
            href: '/recursos/'
          },
          {
            text: resource.title,
            href: `/recursos/${resource.id}/${resource.meta.slug}`
          }
        ]} />
    </div>
  </section>
}

Breadcrumb.propTypes = {
  resource: PropTypes.object
}

export default Breadcrumb
